import { render, staticRenderFns } from "./writeMyName.vue?vue&type=template&id=42e12270&scoped=true&"
import script from "./writeMyName.vue?vue&type=script&lang=js&"
export * from "./writeMyName.vue?vue&type=script&lang=js&"
import style0 from "./writeMyName.vue?vue&type=style&index=0&id=42e12270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e12270",
  null
  
)

export default component.exports